module.exports = require("@gauzy/plugin-knowledge-base");